
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBeaconTowerCube as ObiBeaconTowerCubeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-beacon-tower-cube.js';
 
 
 

 
 export const ObiBeaconTowerCube = createComponent({
   react: React,
   tagName: 'obi-beacon-tower-cube',
   elementClass: ObiBeaconTowerCubeElement,
   events: {
     
   }
  });
 
 